import type { ReportReason } from '@hermes/db/schema';

/** The reasons a member can give when reporting a message, a conversation or a Speedy. One list. */
export const REPORT_REASONS: { id: ReportReason; label: string }[] = [
  { id: 'harassment', label: 'Harassment or bullying' },
  { id: 'spam', label: 'Spam or scam' },
  { id: 'inappropriate', label: 'Inappropriate content' },
  { id: 'other', label: 'Other' },
];
